import React from 'react';

/**
 * Componente para exibir prévia de mensagem WhatsApp
 * Simula a interface de conversas do WhatsApp
 * 
 * @param {Object} props - Propriedades do componente
 * @param {string} props.message - Mensagem processada com variáveis substituídas
 * @returns {JSX.Element} Componente React
 */
const TemplatePreview = ({ message }) => {
  if (!message) return null;
  
  return (
    <div className="bg-gray-100 p-4 rounded-lg">
      <div className="flex items-center mb-3">
        <h3 className="text-sm font-medium text-gray-900">Prévia no WhatsApp</h3>
      </div>
      
      <div className="flex flex-col">
        <div className="max-w-[85%] self-end bg-green-100 text-gray-800 rounded-lg p-3 mb-1 relative">
          <div className="whitespace-pre-line text-sm">
            {message}
          </div>
          <div className="text-right mt-1">
            <span className="text-xs text-gray-500">12:34 ✓✓</span>
          </div>
          
          {/* Triângulo para simular bolha de chat */}
          <div className="absolute bottom-0 right-0 w-4 h-4 transform translate-x-1/2 rotate-45 bg-green-100"></div>
        </div>
      </div>
    </div>
  );
};

export default TemplatePreview;
